var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetaDropdownSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 4,
    viewBox: "0 0 8 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.23726 3.90931C4.10623 4.03023 3.89377 4.03023 3.76274 3.90931L0.0989494 0.528551C-0.112428 0.333503 0.0372787 0 0.336212 0L7.66379 0C7.96272 0 8.11243 0.333503 7.90105 0.528552L4.23726 3.90931Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaDropdownSelect);
export default __webpack_public_path__ + "static/media/seta-dropdown-select.ec7e475b1cc50c0e3883c8eaddcc243f.svg";
export { ForwardRef as ReactComponent };